import { render, staticRenderFns } from "./vFormSHORT_ANSWER.vue?vue&type=template&id=4083d7da&"
import script from "./vFormSHORT_ANSWER.vue?vue&type=script&lang=js&"
export * from "./vFormSHORT_ANSWER.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports